export enum CookieStorageKeys {
  previouslySavedEmail = 'previouslySavedEmail',
  previouslySavedName = 'previouslySavedName',
}
